import React from "react";
import { Outlet } from "react-router-dom";

const Shopping = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default Shopping;
